import React, { useEffect, useState } from "react";
import "./home.less";
import FontIcon from "@/components/YhIcon";
import { KeyWords } from "./KeyWords";
import { Wordcloud } from "./WordCloud";
import { CarouselInfo } from "./CarouselInfo";
import { GatherInfo } from "./GatherInfo";
import { DiscernWeekLine } from "./DiscernWeekLine";
import { DiscernMonthLine } from "./DiscernMonthLine";
import { QuickNav } from "./QuickNav";
import { HomeProgress } from "./Progress";
import { HomeCard } from "./HomeCard";
import { useHistory } from "react-router-dom";
import { useGlobalModel } from "@/model/globalModel";
import { useNavModel } from "@/model/navModel";
import { loginServiceAuth2 } from "../login/LoginServiceAuth2";
import { CLIENT_APP_CODE } from "@/utils/constants";
import { closeWebPage } from "@/utils/utils";
import moment from "moment";

export function Home() {
    const history = useHistory();
    const { user, setUser, } = useGlobalModel(({ user }) => [user]);
    const { initNav } = useNavModel(() => []);
    const [currentTime, setCurrentTime] = useState<string>("");

    //退出登录
    const onLogout = () => {
        if (user.loginType === "account") {
            setUser({ ...user, shopId: "", shopName: "", token: "" });
            initNav();
            history.push("/login");
            loginServiceAuth2.Logout();
            loginServiceAuth2.recordAppLogoutInfo(CLIENT_APP_CODE, user.userCode ?? "");
        } else {
            closeWebPage();
        }
    };

    let timer: NodeJS.Timeout;
    useEffect(() => {
        document.body.setAttribute("class", "overflow-x-hidden");
        timer = setInterval(() => {
            setCurrentTime(() => moment().format('YYYY-MM-DD HH:mm:ss'))
        }, 1000);
        return () => {
            document.body.removeAttribute("overflow-x-hidden");
            clearTimeout(timer);
        }
    }, []);

    return (
        <div className="home-container" id="home-container">
            <div className="home-header">
                <div className="home-header-left">
                    <span className="home-header-left-time">时间：{currentTime} </span>
                </div>
                <div className="home-header-center">
                    <span className="home-header-center-title">招投标信息采集分析管理平台</span>
                </div>
                <div className="home-header-right">
                    <FontIcon type="icon-tuichu" className="home-header-right-logout" onClick={() => onLogout()} />
                </div>
            </div>

            <div className="home-content">
                <div className="home-content-left">
                    {/*总数卡片*/}
                    <HomeCard />
                    {/*能量进度条*/}
                    <HomeProgress />
                    {/*关键词饼图 */}
                    <KeyWords />
                </div>
                <div className="home-content-center">
                    {/*词云图*/}
                    <Wordcloud />
                    {/*文字向上滚动*/}
                    <CarouselInfo />
                    {/*收集信息统计*/}
                    <GatherInfo />
                </div>
                <div className="home-content-right">
                    {/*周过滤/识别数量分析*/}
                    <DiscernWeekLine />
                    {/*周过滤/识别数量分析*/}
                    <DiscernMonthLine />
                    {/*网站快速导航*/}
                    <QuickNav />
                </div>
            </div>
        </div>
    )
}  